// extracted by mini-css-extract-plugin
export default {"body_styleDefault":"c-a_fz","body_styleRed":"c-a_fA"};